import React, { useMemo } from 'react'

import styles from './Permissions.module.css'
import LockIcon from 'Icons/lock-locked.svg'

import Switch from 'Design/components/Switch'

import { useGetAccountQuery } from 'Services/account'

const PERMISSION_GROUPS = {
  manage_users: {
    prefix: 'user_'
  }
}

const getGroupedPermissions = (groupName, allPermissions = []) => {
  const permissionGroup = PERMISSION_GROUPS[groupName]

  if (permissionGroup.prefix) {
    const permisisonGroups = allPermissions.filter((permission) => permission.startsWith(permissionGroup.prefix))
    return permisisonGroups
  }

  return []
}

const isGroupChecked = (permissionName, permisisons = [], allPermissions = []) => {
  const permissionGroup = PERMISSION_GROUPS[permissionName]

  if (!permissionGroup) {
    return permisisons.includes(permissionName)
  }

  const permisisonGroups = getGroupedPermissions(permissionName, allPermissions)
  return permisisonGroups.every((permission) => permisisons.includes(permission))
}

const Permissions = (props) => {
  const { permissions = [], onChange } = props

  const { allPermissions } = useGetAccountQuery(null, {
    selectFromResult: ({ data }) => ({
      allPermissions: data?.permissions.allPermissions || []
    })
  })

  const permissionsList = useMemo(() => {
    return [
      {
        name: 'manage_users',
        description: 'Manage users',
        group: true,
        permissions: getGroupedPermissions('manage_users', allPermissions),
        checked: isGroupChecked('manage_users', permissions, allPermissions)
      }
    ]
  }, [permissions, allPermissions])

  const togglePermissions = (item, checked) => {
    if (!checked) {
      const newPermissions = permissions.filter((permission) => !item.permissions.includes(permission))
      return onChange(newPermissions)
    }

    const newPermissions = new Set([...permissions, ...item.permissions])
    onChange(Array.from(newPermissions))
  }

  return (
    <div className={styles.Container}>
      <div className={styles.Heading}>
        <LockIcon width='1em' height='1em' /> Permissions
      </div>

      <div className={styles.PermissionsList}>
        {permissionsList.map((permission) => {
          return (
            <div className={styles.Permission} key={`Permission__${permission.name}`}>
              {permission.description}

              <div className={styles.PermissionSwitch}>
                <Switch
                  checked={permission.checked}
                  onChange={(e) => togglePermissions(permission, e.target.checked)}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Permissions
